import React from 'react';

import PropTypes from 'prop-types';

import { ShopPromiseTag } from './shop-promise-tag';
import { PremiumProgram } from '../../enums/premium-program';
import { emptyArray } from 'ui-components/default-props/empty';
import { WalmartSimplifiedShippingTag } from './walmart-simplified-shipping-tag';
import { TemuPreSaleTag } from './temu-pre-sale-tag';
import { TemuMadeToOrderTag } from './temu-made-to-order-tag';
import { TikTokExpressShippingTag } from './tiktok-express-shipping-tag';

const premiumProgramComponentMap = {
  [PremiumProgram.ShopPromise]: ShopPromiseTag,
  [PremiumProgram.WalmartSimplifiedShipping]: WalmartSimplifiedShippingTag,
  [PremiumProgram.TemuPreSale]: TemuPreSaleTag,
  [PremiumProgram.TemuMadeToOrder]: TemuMadeToOrderTag,
  [PremiumProgram.TikTokExpressShipping]: TikTokExpressShippingTag,
};

export const PremiumProgramTags = ({ premiumPrograms = emptyArray }) => {
  return premiumPrograms?.map((premiumProgramId) => {
    const PremiumProgramTag = premiumProgramComponentMap[premiumProgramId];
    return PremiumProgramTag ? <PremiumProgramTag key={premiumProgramId} /> : null;
  });
};

PremiumProgramTags.propTypes = {
  premiumPrograms: PropTypes.arrayOf(PropTypes.string),
};
